export enum NotificationType {
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error'
}
